import RelatoriosService from '@/services/RelatoriosService.js';

export default {
  data() {
    return {
      downloadProgressData: {}
    };
  },
  methods: {
    async downloadSpreadSheet(id, tipo = 'xlsx', nome = '') {
      this.$set(this.downloadProgressData, id, { id });
      this.$toast.info('Preparando seu arquivo para download.', '', {
        position: 'topRight',
        timeout: 2500
      });

      try {
        await this.baixarArquivo(id, tipo, nome);
      } catch (error) {
        console.error(error);
        this.$toast.error('Erro no download do arquivo.', '', {
          position: 'topRight'
        });
      } finally {
        this.$delete(this.downloadProgressData, id);
      }
    },
    baixarArquivo(id, tipo, nome) {
      const config = {
        timeout: 60 * 60 * 1000,
        onDownloadProgress: (progressEvent) => {
          let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          let isComputable = progressEvent.lengthComputable;
          this.$set(this.downloadProgressData, id, {
            progress,
            isComputable,
            id
          });
        }
      };

      const automatico = !tipo || tipo === 'xlsx';
      const request = automatico
        ? RelatoriosService.baixarArquivoPlanilha(id, config)
        : RelatoriosService.getRelatorioSpreadSheet(id, tipo, config);

      return request.then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.montarNomeArquivo(id, nome, this.getExtensaoArquivo(response, tipo)));
        document.body.appendChild(link);
        link.click();
      });
    },
    montarNomeArquivo(id, nome, ext) {
      const base = nome ? `Resultado Relatório ${id} ${nome}.${ext}` : `Resultado Relatório ${id}.${ext}`;
      return base.replace(/ /g, '_');
    },
    getExtensaoArquivo(response, tipo) {
      const mime = ((response.data && response.data.type) || (response.headers && response.headers['content-type']) || '')
        .split(';')[0]
        .trim()
        .toLowerCase();

      if (['application/zip', 'application/x-zip-compressed', 'application/x-zip'].includes(mime)) {
        return 'zip';
      }
      if (mime === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        return 'xlsx';
      }
      if (['text/csv', 'application/csv'].includes(mime)) {
        return 'csv';
      }

      if (tipo === 'csv' || tipo === 'csv-custom') {
        return 'csv';
      }
      return 'xlsx';
    }
  }
};
